import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "notfound" };
const _hoisted_2 = { class: "notfound" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "notfound-404" }, [
                _createElementVNode("h1", null, "Oops!"),
                _createElementVNode("h2", null, "404 - Seite nicht gefunden")
            ], -1)),
            _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("zurück zur Startseite", -1)
                    ]))]),
                _: 1
            })
        ])
    ]));
}
